import Icon from "./logo";
import { getArraySetterSnippet } from "../../common/manager/setter-snippet";
var CnLayoutHeaderPrototype = {
  title: '页头',
  componentName: 'CnLayoutHeader',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  configure: [{
    name: 'isCnLayoutHeader',
    title: 'CnLayoutHeader',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }, {
    name: 'title',
    title: '标题',
    display: 'inline',
    setter: 'CnI18nSetter',
    supportVariable: true
  }, {
    name: 'desc',
    title: '描述',
    display: 'inline',
    setter: 'CnI18nSetter',
    supportVariable: true
  }, {
    name: 'avatar.src',
    title: '头像',
    display: 'inline',
    setter: 'StringSetter',
    supportVariable: true
  }, {
    name: 'label',
    title: '标签',
    display: 'inline',
    supportVariable: true,
    setter: getArraySetterSnippet({
      configure: [{
        name: 'name',
        title: '名称',
        setter: 'CnI18nSetter',
        isRequired: true
      }]
    })
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export { CnLayoutHeaderPrototype };